import { PitchListHelper } from 'classes/helpers/pitch-list.helper';
import { CommonDialog } from 'components/common/dialogs';
import { ErrorBoundary } from 'components/common/error-boundary';
import { MachineContext } from 'contexts/machine.context';
import { t } from 'i18next';
import { ArrayHelper } from 'lib_ts/classes/array.helper';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IPitch } from 'lib_ts/interfaces/pitches';
import React, { useContext } from 'react';
import ReactMarkdown from 'react-markdown';
import { useTrainedMsStore } from 'stores/use-trained-ms-store';

const COMPONENT_NAME = 'ResetTrainingDialog';

interface IProps {
  pitches: IPitch[];
  onClose: (success: boolean) => void;
}

export const ResetTrainingDialog: React.FC<IProps> = ({ pitches, onClose }) => {
  const { lastPitchID, machine, resetMSHash } = useContext(MachineContext);
  const loading = useTrainedMsStore((s) => s.loading);

  const isSingle = pitches.length === 1;

  const handleReset = async () => {
    const success = await useTrainedMsStore.getState().deleteTrainedMss({
      machineID: machine.machineID,
      ball_type: machine.ball_type,
      bs_hashes: ArrayHelper.unique(pitches.map((p) => p.bs_hash)),
    });

    if (!success) {
      return;
    }

    if (pitches.findIndex((p) => p._id === lastPitchID) !== -1) {
      resetMSHash();
    }

    onClose(true);
  };

  return (
    <ErrorBoundary identifier={COMPONENT_NAME}>
      <CommonDialog
        identifier={COMPONENT_NAME}
        width={RADIX.DIALOG.WIDTH.SM}
        title="common.reset-training-data"
        loading={loading}
        content={
          <ReactMarkdown
            children={[
              t('pl.confirm-reset-x', {
                x: t(
                  isSingle ? 'common.pitch' : 'common.pitches'
                ).toLowerCase(),
              }),
              PitchListHelper.enumeratePitches(pitches, 5),
              t('pl.warning-reset-impact'),
            ].join('\n\n')}
          />
        }
        buttons={[
          {
            label: 'common.continue',
            color: RADIX.COLOR.WARNING,
            onClick: handleReset,
          },
        ]}
        onClose={() => onClose(false)}
      />
    </ErrorBoundary>
  );
};
